import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { t } from 'i18next';
import { getTenantState } from '../../../store/selectors';
import { registerCopy } from '../../../copy/registerCopy.json';

function GradYearDropdown(props) {
  const handleYearSelected = (year) => {
    props.setGradYearParent(year.value);
  };

  function generateYearChoices(currentYear) {
    const yearsRange = Array.from(
      { length: 29 },
      (_, index) => currentYear - 24 + index
    );
    const yearChoices = yearsRange.map((year) => ({
      value: year,
      label: year,
    }));

    return yearChoices;
  }
  const currentYear = new Date().getFullYear();
  const yearChoices = generateYearChoices(currentYear);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      color: props.tenant.primary,
    }),
    input: (provided) => ({
      ...provided,
      color: props.tenant.primary,
      width: '100%',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: props.tenant.primary,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: props.tenant.primary,
      overflow: 'visible',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: props.tenant.primary,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 100,
    }),
  };

  return (
    <div className="dropdown select-graduation">
      <Select
        menuPortalTarget={document.body}
        onChange={handleYearSelected}
        options={yearChoices}
        className="grad-year-dropdown"
        id="graduationYear"
        styles={customStyles}
        placeholder={props.graduationYear || t(registerCopy.dropdown2)}
        aria-label={props.graduationYear || t(registerCopy.dropdown2)}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);

  return { tenant };
};

export default connect(mapStateToProps, {})(GradYearDropdown);
